import { Vector2 } from "three";
import { Colors } from "../../../library-js/colors/Colors";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { Canvas2dBase } from "../../../library-js/dom-ui/graphical/Canvas2dBase";
import { TemplateDefaults } from "../../TemplateDefaults";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphEdge } from "../model/NodeGraphEdge";

export class EdgesRenderingLayer extends Canvas2dBase
{
  _nodeGraph:NodeGraph;


  constructor( ng:NodeGraph, e:Element )
  {
    super( e );
    this._nodeGraph = ng;
    this.setFlags( TemplateDefaults.noPointers );    
  }

  protected _update():void
  {
    this.clear();

    
    this._selected = 0;
    this._nodeGraph._edges.forEach(
      ( e )=>
      {
        this._drawEdge( e );
      }
    );

    console.log( "selected eges:", this._selected )
  }

  _startOffset = new Vector2( 50, 0 );
  _endOffset   = new Vector2( -50, 0 );

  _start2:Vector2 = new Vector2();
  _end2:Vector2 = new Vector2();

  _selected:number = 0;

  _drawEdge( edge:NodeGraphEdge )
  {
    let start = edge._fromConnector._outputConnectorPosition;
    let end   = edge._toConnector._inputConnectorPosition;

    
    if ( this._nodeGraph._selection.has( edge ) )
    {
      this.context.strokeStyle = "white";
      this._selected ++;
      
    }
    else
    {
      let lg = this.context.createLinearGradient( start.x, start.y, end.x, end.y );
      lg.addColorStop( 0, edge._fromConnector._outputColor + "" );
      lg.addColorStop( 1, edge._toConnector._inputColor + "" );
      this.context.strokeStyle = lg;
    }

    
    this.context.lineWidth = 2;
    
    this._start2.copy( start ).add( this._startOffset );
    this._end2.copy( end ).add( this._endOffset );

    this.drawBezier( start, this._start2, this._end2, end );

    if ( edge._hovered )
    {
      this.context.lineWidth = 6;
      this.context.strokeStyle = new HSLColor( 0, 0, 100, 0.5 ) + "";
      this.drawBezier( start, this._start2, this._end2, end );
    }

  }

  ensureCanvasSize()
  {    
    if ( ! this._nodeGraph._controller._nodeGraphEvent )
    {
      return;
    }

    if ( 

      this.canvas.width === this._nodeGraph._controller._nodeGraphEvent.size.x &&
      this.canvas.height === this._nodeGraph._controller._nodeGraphEvent.size.y 
    )
    {
      return;
    }

    this.canvas.width  =this._nodeGraph._controller._nodeGraphEvent.size.x;
    this.canvas.height = this._nodeGraph._controller._nodeGraphEvent.size.y ;

    this.dimensions.width = this._nodeGraph._controller._nodeGraphEvent.size.x;
    this.dimensions.height = this._nodeGraph._controller._nodeGraphEvent.size.y;
  }
}